'use client';

import { FallbackImage } from '@/components/commons/fallback-image';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { cn } from '@/lib/utils';
import React from 'react';

type ImageNavItemProps = {
  title: string;
  src: string;
  parentData?: HeaderElementDataType;
};

export default function HeaderMenuImage({ title, src, parentData }: ImageNavItemProps) {
  return (
    <div className='relative'>
      <div
        className={cn(
          'absolute left-0 top-0 z-10 h-full w-full',
          parentData?.megaMenuImageOverlay ? 'bg-black opacity-10' : ''
        )}
      ></div>
      <FallbackImage
        src={src}
        alt={title}
        width={200}
        height={200}
        quality={100}
        unoptimized
        className='object-cover'
      />
      <h3
        className='absolute bottom-2 left-3 z-20 text-xl font-bold'
        style={{
          color: parentData?.colorSchemeMenuHeader?.text,
        }}
      >
        {title}
      </h3>
    </div>
  );
}
